import React from "react";
import "./Header.css";
import { useStateValue } from "./StateProvider";
import { Avatar } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { useEffect } from "react";

function Header({ spotify }) {
  const [{ user }, dispatch] = useStateValue();

  return (
    <div className="header">
      <div className="header__left">
        <SearchIcon />
        <input placeholder="Search" type="text" />
      </div>
      <div className="header__right">
        <Avatar
          className="avatar"
          alt={user?.display_name}
          src={user?.images[0].url}
        />
        <span>{user?.display_name}</span>
      </div>
    </div>
  );
}

export default Header;
